import {Component, OnInit} from '@angular/core';
import {ArticleListItem} from "../model/article-list-item";
import {MessageService} from "../service/message.service";
import {ArticleService} from "../service/article.service";

@Component({
  selector: 'app-articles',
  templateUrl: './articles.component.html',
  styleUrls: ['./articles.component.css']
})
export class ArticlesComponent implements OnInit {

  articles: ArticleListItem[];

  constructor(private messageService: MessageService,
              private articleService: ArticleService) {
  }

  ngOnInit() {
    this.refreshArticles();
  }

  private refreshArticles() {
    this.articleService.getArticles().toPromise().then(value => this.articles = value).catch(this.onRejected());
  }

  onDeleteArtice(article: ArticleListItem) {
    if (confirm("Do you want to delete this record?")) {
      this.articleService.deleteArticle(article.id).then(() => this.refreshArticles()).catch(this.onRejected());
    }
  }

  private onRejected() {
    return err => {
      this.messageService.addError('error occurred', err);
      console.log(err);
    }
  }

  onChangePosition(article: ArticleListItem, newPosition: number) {
    console.log(`move ${article.title} from ${article.position} to ${newPosition}`);
    this.articleService.moveArticle(article.id, newPosition)
      .then(() => this.refreshArticles())
      .catch(this.onRejected());
  }
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/articles/articles.component.ts